import React, {useEffect, useState} from "react";
import {useGlobal} from "../../Store";
import {Link} from "react-router-dom";
import {postData} from "../../Utils/Server";
import Endpoints from "../../Constants/Endpoints";
import {useHistory} from "react-router-dom";
import {ERROR, Notify, SUCCESS} from "../../Utils/Notify";
import {updateDocumentTitle} from "../../Utils/Common";
import {ReasonCaptureModal} from "../Common/ReasonCaptureModal";
import styled from "styled-components";
import PageLayout from "../Layout/PageLayout";
import {Button, Card, CardTitleBar, CardBody, Tabs, DataTable, FormField, TextInput, Select, Spinner, StatusBadge, Modal} from "../UI";
import {tokens} from "../../theme/tokens";

const InfoTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    td {
        padding: ${tokens.spacing[3]} ${tokens.spacing[4]};
        border-bottom: 1px solid ${tokens.colors.divider};
        font-size: ${tokens.typography.size.base};
        vertical-align: top;
    }
    td:first-child {
        color: ${tokens.colors.muted};
        width: 40%;
    }
    td:last-child {
        color: ${tokens.colors.heading};
    }
    tr:last-child td {
        border-bottom: 0;
    }
`;

const AccountDetails = props => {
    let history = useHistory();
    const [globalState, globalActions] = useGlobal();
    const [isLoading, setIsLoading] = useState(false);
    const [item, setItem] = useState({name: ''});
    const [pendingAction, setPendingAction] = useState(null);
    const [tab, setTab] = useState("details");

    const [requestsListOngoing, setRequestListOngoing] = useState([]);
    const [requestsListAll, setRequestListAll] = useState([]);
    const [businessList, setBusinessList] = useState([]);

    const [ratesList, setRatesList] = useState([]);
    const [requestType, setRequestType] = useState('');
    const [meansType, setMeansType] = useState('');
    const [peakRate, setPeakRate] = useState('');
    const [normalRate, setNormalRate] = useState('');

    const [requestTypeList, setRequestTypeList] = useState([]);
    const [meansTypeList, setMeansTypeList] = useState([]);

    // Team-member management state.
    const [departmentOptions, setDepartmentOptions] = useState([]);
    const [transferOpen, setTransferOpen] = useState(false);
    const [transferDept, setTransferDept] = useState('');
    const [confirmDelete, setConfirmDelete] = useState(false);

    const columns = [
        {
            name: '#',
            sortable: true,
            cell: row => <div><Link to={"/request/" + row.id}>{row.request_code}</Link></div>,
        },
        {
            name: 'Type',
            selector: 'pick_up_type',
            sortable: true,
        },
        {
            name: 'Pick up',
            selector: 'pick_up_location',
            sortable: true,
        },
        {
            name: 'Delivery type',
            selector: 'delivery_type',
            sortable: true,
        },
        {
            name: 'Means',
            selector: 'means',
            sortable: true,
        },
        {
            name: 'Status',
            selector: 'status',
            sortable: true,
        },
        {
            name: 'Fee',
            selector: 'fee',
            sortable: true,
        }
    ]

    const ratesColumns = [
        {
            name: 'Request Type',
            selector: 'request_type',
            sortable: true,
        },
        {
            name: 'Means Type',
            selector: 'means_type',
            sortable: true,
        },
        {
            name: 'Normal Rate',
            selector: 'normal_rate',
            sortable: true,
        },
        {
            name: 'Peak Rate',
            selector: 'peak_rate',
            sortable: true,
        },
        {
            name: '',
            cell: row => <Button size="sm" variant="danger"
                                 onClick={e => deleteRate(row.id)}>Delete</Button>,
        },
    ]

    const {id} = props.match.params;

    const load = () => {
        let data = new FormData();
        data.append("id", id);

        setIsLoading(true);
        postData(Endpoints.CHILD_ACCOUNT_DETAIL, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    setItem(res.data);
                    updateDocumentTitle(res.data.email)
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    };

    useEffect(() => {
        load()
        loadRequests(false, "business")
        loadRates()
        loadMeansTypes()
        loadRequestTypes()
    }, []);

    function updateStatus(number, reason) {
        let data = new FormData();
        data.append("id", id);
        data.append("status", number);
        data.append("reason", reason);

        setIsLoading(true);
        postData(Endpoints.CHILD_ACCOUNT_UPDATE_STATUS, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                Notify(SUCCESS ? res.data : res.message, res.success === 1 ? SUCCESS : ERROR);

                if (res.success === 1) {
                    load()
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    const loadRequests = (loadMore, status) => {
        let data = new FormData();
        data.append("child_account_id", id);
        data.append("status", status);
        data.append("offset", requestsListOngoing.length);

        setIsLoading(true);

        postData(Endpoints.REQUEST_LIST_USER, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                let currentPosts = loadMore ? requestsListOngoing : [];
                currentPosts = currentPosts.concat(...res.data);
                setRequestListOngoing(currentPosts);
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    };

    function loadRates() {
        let data = new FormData();
        data.append("user_id", id);
        setIsLoading(true)
        postData(Endpoints.RATE_LIST, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    setRatesList(res.data || []);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    function addRates(e) {
        e.preventDefault()

        let data = new FormData();
        data.append("user_id", id);
        data.append("request_type", requestType)
        data.append("means_type", meansType)
        data.append("normal_rate", normalRate)
        data.append("peak_rate", peakRate)

        setIsLoading(true)
        postData(Endpoints.RATE_ADD, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                Notify(res.success === 1 ? res.data : res.message, res.success === 1 ? SUCCESS : ERROR);
                if (res.success === 1) {
                    setNormalRate('')
                    setPeakRate('')
                    loadRates()
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }


    function deleteRate(id) {

        let data = new FormData();
        data.append("id", id);

        setIsLoading(true)
        postData(Endpoints.RATE_DELETE, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                Notify(res.success === 1 ? res.data : res.message, res.success === 1 ? SUCCESS : ERROR);
                if (res.success === 1) {
                    loadRates()
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    function loadRequestTypes() {
        let data = new FormData();
        setIsLoading(true)
        postData(Endpoints.REQUEST_TYPE_LIST, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    setRequestTypeList(res.data || []);
                    if (res.data.length > 0) setRequestType(res.data[0].name)
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    function loadMeansTypes() {
        let data = new FormData();
        setIsLoading(true)
        postData(Endpoints.MEANS_TYPE_LIST, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    setMeansTypeList(res.data || []);
                    if (res.data.length > 0) setMeansType(res.data[0].name)
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }


    // Load selectable departments (same business) for the transfer picker.
    useEffect(() => {
        if (!item.business_id) return;
        let data = new FormData();
        data.append("business_id", item.business_id);
        postData(Endpoints.DEPARTMENT_LIST, data)
            .then(res => res.json())
            .then(res => setDepartmentOptions((res && res.data) || []))
            .catch((error) => console.log(error));
    }, [item.business_id]);

    const resendInvitation = () => {
        let data = new FormData();
        data.append("id", id);
        setIsLoading(true);
        postData(Endpoints.CHILD_ACCOUNT_RESEND_INVITE_ADMIN, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                Notify(res.success === 1 ? (res.data || "Invitation resent") : (res.message || res.error || "Failed"),
                    res.success === 1 ? SUCCESS : ERROR);
            })
            .catch((error) => { setIsLoading(false); console.log(error); });
    };

    const transferAccount = () => {
        if (!transferDept) return;
        let data = new FormData();
        data.append("id", id);
        data.append("department_id", transferDept);
        setIsLoading(true);
        postData(Endpoints.CHILD_ACCOUNT_TRANSFER_ADMIN, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                Notify(res.success === 1 ? (res.data || "Account transferred") : (res.message || res.error || "Failed"),
                    res.success === 1 ? SUCCESS : ERROR);
                if (res.success === 1) {
                    setTransferOpen(false);
                    setTransferDept('');
                    load();
                }
            })
            .catch((error) => { setIsLoading(false); console.log(error); });
    };

    const deleteAccount = () => {
        let data = new FormData();
        data.append("id", id);
        setIsLoading(true);
        postData(Endpoints.CHILD_ACCOUNT_DELETE_ADMIN, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                Notify(res.success === 1 ? (res.data || "Account deleted") : (res.message || res.error || "Cannot delete this account"),
                    res.success === 1 ? SUCCESS : ERROR);
                if (res.success === 1) {
                    setConfirmDelete(false);
                    history.push('/department/' + item.department_id);
                }
            })
            .catch((error) => { setIsLoading(false); console.log(error); });
    };

    const isAccepted = item.accepted === 1;
    const hasHistory = Number(item.this_months_requests) > 0;

    return (
        <PageLayout
            title={item.email}
            actions={item.name !== '' ? (
                <>
                    {isLoading && <Spinner size={20}/>}
                    <StatusBadge tone={isAccepted ? "success" : "warn"}>
                        {isAccepted ? "Accepted" : "Pending"}
                    </StatusBadge>
                    {!isLoading &&
                    <Button
                        variant={item.admin_active === 1 ? "danger" : "primary"}
                        onClick={e => setPendingAction(item.admin_active === 1 ? 0 : 1)}
                    >
                        {item.admin_active === 1 ? "Deactivate" : "Activate"}
                    </Button>
                    }
                    {!isAccepted &&
                    <Button variant="outline" onClick={resendInvitation}>Resend invitation</Button>
                    }
                    <Button variant="outline" onClick={() => { setTransferDept(''); setTransferOpen(true); }}>Transfer</Button>
                    <Button
                        variant="danger"
                        disabled={hasHistory}
                        title={hasHistory ? "Cannot delete — account has delivery activity this month" : "Delete account"}
                        onClick={() => setConfirmDelete(true)}
                    >
                        Delete
                    </Button>
                    <Link to={"/department/" + item.department_id}>
                        <Button variant="outline">Back to department</Button>
                    </Link>
                </>
            ) : null}
        >
            {item.name !== '' &&
            <>
                <Tabs
                    tabs={[
                        {key: "details", label: "Details"},
                        {key: "requests", label: "Requests made"},
                        {key: "rates", label: "Rates & Charges"},
                    ]}
                    value={tab}
                    onChange={setTab}
                />

                {tab === "details" &&
                <Card>
                    <InfoTable>
                        <tbody>
                        <tr>
                            <td>Email</td>
                            <td><b>{item.email}</b></td>
                        </tr>
                        <tr>
                            <td>Invitation status</td>
                            <td>
                                <StatusBadge tone={isAccepted ? "success" : "warn"}>
                                    {isAccepted ? "Accepted" : "Pending"}
                                </StatusBadge>
                            </td>
                        </tr>
                        <tr>
                            <td>This month's bill</td>
                            <td><b>{item.this_month_string}</b></td>
                        </tr>
                        <tr>
                            <td>This month's requests</td>
                            <td><b>{item.this_months_requests}</b></td>
                        </tr>
                        <tr>
                            <td>Client Status</td>
                            <td><b>{item.active === 0 ? "INACTIVE" : "ACTIVE"}</b></td>
                        </tr>
                        <tr>
                            <td>Admin Status</td>
                            <td><b>{item.admin_active === 0 ? "INACTIVE" : "ACTIVE"}</b></td>
                        </tr>
                        <tr>
                            <td>Registered on</td>
                            <td><b>{item.date_added_string}</b></td>
                        </tr>
                        </tbody>
                    </InfoTable>
                </Card>
                }

                {tab === "requests" &&
                <Card padded={false}>
                    <DataTable
                        columns={columns}
                        data={requestsListOngoing}
                        pointerOnHover={true}
                        noHeader={true}
                        onRowClicked={e => {
                            history.push('/request/' + e.id);
                        }}
                    />
                </Card>
                }

                {tab === "rates" &&
                <div className="row">
                    <div className="col-md-8">
                        <Card padded={false}>
                            <DataTable
                                columns={ratesColumns}
                                data={ratesList}
                                pointerOnHover={true}
                                noHeader={true}
                            />
                        </Card>
                    </div>
                    <div className="col-md-4">
                        <Card padded={false}>
                            <CardTitleBar title="Add new rate"/>
                            <CardBody>
                                <form onSubmit={addRates}>
                                    <FormField label="Select request type">
                                        <Select
                                            value={requestType}
                                            onChange={({target}) => setRequestType(target.value)}>
                                            {requestTypeList.map((i, k) => <option
                                                value={i.name}>{i.name}</option>
                                            )}
                                        </Select>
                                    </FormField>

                                    <FormField label="Select means type">
                                        <Select
                                            value={meansType}
                                            onChange={({target}) => setMeansType(target.value)}>
                                            {meansTypeList.map((i, k) => <option
                                                value={i.name}>{i.name}</option>
                                            )}
                                        </Select>
                                    </FormField>

                                    <FormField label="Normal rate per KM in KES">
                                        <TextInput type="number"
                                                   required={true}
                                                   value={normalRate}
                                                   onChange={e => setNormalRate(e.target.value)}
                                        />
                                    </FormField>

                                    <FormField label="Peak rate per KM in KES">
                                        <TextInput type="number"
                                                   required={true}
                                                   value={peakRate}
                                                   onChange={e => setPeakRate(e.target.value)}
                                        />
                                    </FormField>

                                    {isLoading ?
                                        <Spinner size={23}/> :
                                        <Button type="submit">Add</Button>
                                    }
                                </form>
                            </CardBody>
                        </Card>
                    </div>
                </div>
                }
            </>
            }
            {pendingAction !== null &&
            <ReasonCaptureModal
                title={pendingAction === 0 ? "Deactivate child account" : "Activate child account"}
                onCancel={() => setPendingAction(null)}
                onConfirm={reason => { updateStatus(pendingAction, reason); setPendingAction(null); }}
            />
            }

            <Modal
                open={transferOpen}
                onClose={() => setTransferOpen(false)}
                title="Transfer team member"
                subtitle="Move this account to another department in the same business."
                actions={
                    <>
                        <Button variant="ghost" onClick={() => setTransferOpen(false)}>Cancel</Button>
                        <Button disabled={!transferDept} onClick={transferAccount}>Transfer</Button>
                    </>
                }
            >
                <FormField label="Destination department" htmlFor="transferDept">
                    <Select id="transferDept" value={transferDept} onChange={e => setTransferDept(e.target.value)}>
                        <option value="">Select a department…</option>
                        {departmentOptions
                            .filter(d => String(d.id) !== String(item.department_id))
                            .map(d => <option key={d.id} value={d.id}>{d.name}</option>)}
                    </Select>
                </FormField>
            </Modal>

            <Modal
                open={confirmDelete}
                onClose={() => setConfirmDelete(false)}
                title="Delete team member"
                subtitle="This permanently removes the account. It is only allowed when the account has no delivery history."
                actions={
                    <>
                        <Button variant="ghost" onClick={() => setConfirmDelete(false)}>Cancel</Button>
                        <Button variant="danger" onClick={deleteAccount}>Delete</Button>
                    </>
                }
            >
                Are you sure you want to delete <b>{item.email}</b>?
            </Modal>
        </PageLayout>
    )
};


export default AccountDetails
